
const apiProxy = require('./apiProxy.js');
const stateManager = require('../state/stateManager.js');
const stringUtil = require('../string/stringUtil.js');
const constants = require('../domain/constants');

export async function updateSnoozePropertyConfiguration()
{
    let activeSnoozeProperties = await apiProxy.get("activeSnoozeProperties")
    const state = stateManager.getStore().getState();
    const channel = state.channel;
    

    activeSnoozeProperties = activeSnoozeProperties.filter(x => ((stringUtil.isStringNullOrEmpty(x.channel) || stringUtil.areStringSame(x.channel, channel)) 
                                                                    && (x.venueCodes.length === 0 || x.venueCodes.includes(constants.venueCode.webApp))));

    state.activeSnoozeProperties = activeSnoozeProperties;
}